/* GMV Popup Newsletter - UI Helper
 * Visual feedback helpers for the newsletter popup form
 */

document.addEventListener('DOMContentLoaded', function() {
  var emailInput = document.getElementById('gmv-email');
  var submitArrow = document.getElementById('gmv-submit-arrow');

  if (emailInput) {
    emailInput.addEventListener('input', function() {
      var isValid = emailInput.validity.valid && emailInput.value.trim() !== '';
      var container = emailInput.closest('.form-row-email');
      if (container) {
        if (isValid) {
          container.style.borderColor = '#4CAF50';
        } else if (emailInput.value.trim() !== '') {
          container.style.borderColor = '#f44336';
        } else {
          container.style.borderColor = '';
        }
      }
    });
  }

  var checkboxes = document.querySelectorAll('.checkbox-row input[type="checkbox"]');
  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      var label = document.querySelector('label[for="' + checkbox.id + '"]');
      if (label) {
        label.style.color = checkbox.checked ? '#fff' : '';
      }
    });
  });
});
